import { list } from '@fitogest/reactive-form-builder/utils';
import { FincasModel } from '../../../../../../models/form-common/fincas.module';

export class SubcontratosListsDefinition {
    public fincas = list<FincasModel>();
}
